import type { FC } from 'react';
import { useI18NSummaryHelpContent } from 'src/components/help-panel/useSummaryHelpContent';
import type { ObjectWithContributors } from 'src/rbac/Permission';
import { useHasPermissionQuery } from 'src/rbac/useHasPermission';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import ComplianceRatingRegister from './ComplianceRatingRegister';
import InternalAuditRatingRegister from './InternalAuditRatingRegister';
import RiskRatingRegister from './RiskRatingRegister';

interface Props {
  risk: ObjectWithContributors;
}

const Tab: FC<Props> = ({ risk }) => {
  useI18NSummaryHelpContent('assessments.tabHelp');
  const complianceMonitoringEnabled = useIsFeatureVisibleToOrg(
    'compliance_monitoring'
  );
  const internalAuditEnabled = useIsFeatureVisibleToOrg('internal_audit');
  const {
    hasPermission: canViewCompliance,
    loading: canViewComplianceLoading,
  } = useHasPermissionQuery('read:compliance_monitoring_assessment', risk);
  const {
    hasPermission: canViewInternalAudit,
    loading: canViewInternalAuditLoading,
  } = useHasPermissionQuery('read:internal_audit_report', risk);

  return (
    <>
      <RiskRatingRegister risk={risk} />
      {complianceMonitoringEnabled &&
        canViewCompliance &&
        !canViewComplianceLoading && <ComplianceRatingRegister risk={risk} />}
      {internalAuditEnabled &&
        canViewInternalAudit &&
        !canViewInternalAuditLoading && (
          <InternalAuditRatingRegister risk={risk} />
        )}
    </>
  );
};

export default Tab;
